export default function TestHeading(prop) {
   return <>
   <h2 className=" size-20 text-center font-[600] text-[#641662] text-[25px] md:text-[30px]  ">
            {prop.heading}
          </h2>
    </>
}